import {mapActions, mapGetters} from 'vuex'
import * as util from '@/lib/util'
import * as types from '@/store/mutation-types/'
import * as apiTop from '@/api/top'
import * as apiWorks from '@/api/works'
import * as apiStudio from '@/api/studio'
import * as apiTalent from '@/api/talent'
import * as apiPress from '@/api/press'
import * as apiNewsletter from '@/api/newsletter'
import * as apiStories from '@/api/stories'
import * as apiArtBanner from '@/api/art_banner'
import * as apiCareers from '@/api/careers'
export default {
  data () {
    return {
      dataloaded: false,
      predefineColors: [
        '#000000',
        '#ffffff'
      ]
    }
  },
  methods: {
    init () {
      if (this.getPageType() === 'edit') {
        const category = this.getPageCategory()
        if (category === 'top' || category === 'talent') {
          this.getWorks()
        }
        if (category === 'studio') {
          this.getTalent()
        }
        this.getDetail()
      } else {
        this.dataloaded = true
      }
    },
    getAPI (preview) {
      let api = null
      const category = this.getPageCategory()
      if (category === 'talent') {
        api = apiTalent
      } else if (category === 'works') {
        api = apiWorks
      } else if (category === 'studio') {
        console.log('studio')
        api = apiStudio
      } else if (category === 'press') {
        api = apiPress
      } else if (category === 'newsletter') {
        api = apiNewsletter
      } else if (category === 'top') {
        api = apiTop
      } else if (category === 'stories') {
        api = apiStories
      } else if (category === 'art_banner') {
        api = apiArtBanner
      } else if (category === 'careers') {
        api = apiCareers
      }
      if (preview) {
        api = '/cms/preview/' + category
      }
      return api
    },
    getDetail () {
      const api = this.getAPI()
      const id = this.$route.params.id
      this.$store.commit(types.LOADER, true)
      api.getDetail(id).then((res) => {
        this.dataloaded = true
        if (this.getPageCategory() === 'careers') {
          util.margeObject(this.form, res.data.data)
        } else if (this.getPageCategory() === 'studio') {
          util.margeObject(this.form, res.data.data)
          this.initialForm = JSON.parse(JSON.stringify(this.form))
        } else {
          util.margeObject(this.form, res.data)
          this.initialForm = JSON.parse(JSON.stringify(this.form))
        }
        this.$store.commit(types.LOADER, false)
      })
    },
    onSave () {
      this.$store.commit(types.LOADER, true)
      const api = this.getAPI()
      if (this.getPageType() === 'create') {
        api.post(this.form)
          .then((res) => {
            this.$store.commit(types.LOADER, false)
            this.$message('保存に成功しました')
            this.$router.push({name: this.getPageCategory()})
          })
      } else {
        const id = this.$route.params.id
        api.put(this.form, id)
          .then((res) => {
            this.$store.commit(types.LOADER, false)
            this.$message('保存に成功しました')
            this.getDetail()
          })
      }
    },
    onSaveCareers () {
      this.$store.commit(types.LOADER, true)
      const api = this.getAPI()
      const param = {
        data: this.form
      }
      api.put(param)
        .then((res) => {
          this.$store.commit(types.LOADER, false)
          this.$message('保存に成功しました')
          this.getDetail()
        })
    },
    /**
     * @param lang {String} ja | en
     */
    onPreview (lang) {
      const api = this.getAPI(true)
      this.$store.commit(types.LOADER, true)
      api(this.form, lang)
        .then((res) => {
          this.$store.commit(types.LOADER, true)
          this.$router.push({name: this.getPageCategory()})
        })
    },
    onDelete () {
      const api = this.getAPI()
      const id = this.$route.params.id
      this.$store.commit(types.LOADER, true)
      api.del(id)
        .then((res) => {
          this.$store.commit(types.LOADER, true)
          this.$message('削除しました')
          this.$router.push({name: this.getPageCategory()})
        })
    },
    getPageCategory () {
      let value = null
      const name = this.$route.name
      if (/talent/.test(name)) {
        value = 'talent'
      } else if (/works/.test(name)) {
        value = 'works'
      } else if (/studio/.test(name)) {
        value = 'studio'
      } else if (/press/.test(name)) {
        value = 'press'
      } else if (/newsletter/.test(name)) {
        value = 'newsletter'
      } else if (/top/.test(name)) {
        value = 'top'
      } else if (/stories/.test(name)) {
        value = 'stories'
      } else if (/careers/.test(name)) {
        value = 'careers'
      }

      if (/art_banner/.test(name)) {
        value = 'art_banner'
      }
      return value
    },
    /**
     * @returns {String}
     */
    getPageType () {
      let type = null
      if (/Create/.test(this.$route.name)) {
        type = 'create'
      } else {
        type = 'edit'
      }
      return type
    },
    deleteItem (index) {
      this.$confirm('この要素を削除しますか？', 'Warning', {
        confirmButtonText: '削除する',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      }).then(() => {
        this.form.additional_items.splice(index, 1)
      })
    },
    /**
     * @returns {String}
     */
    getJsonFormData () {
      return JSON.stringify(this.form)
    },
    ...mapActions([
      'getTags',
      'getWorks',
      'getWorkType',
      'getStoriesType',
      'getTalent'
    ]),
    /**
     * トップフィーチャーとタレント関連作品のところに表示する文字列を返す
     * @param {Object} data - id と typeのデータ渡す
     * @returns {String}
     */
    getWorkString (data) {
      let str = ''
      if (data) {
        str = ''
        const workData = this.works.filter((p) => { return p.id === data.id })[0]
        if (workData) {
          str += workData.status ? '公開 : ' : '非公開 : '
          str += workData.title.ja
        } else {
          str += '未設定'
        }
      }
      return str
    },
    getWorkImageUri (data) {
      let str = ''
      if (data) {
        str = undefined
        const workData = this.works.filter((p) => { return p.id === data.id })[0]
        if (workData) {
          str = workData.main_video.image.uri
        }
      }
      return str
    },
    getWorkDetailData (id) {
      return this.works.filter((p) => { return p.id === id })[0]
    },
    getTalentDetail (id) {
      return this.talent.filter((p) => { return p.id === id })[0]
    }
  },
  computed: {
    optionWorks () {
      const p = this.works.filter((p) => { return p.status }).sort((a, b) => {
        const reverse = 1
        if (a.title.ja < b.title.ja) {
          return -1 * reverse
        } else if (a.title.ja === b.title.ja) {
          return 0
        } else {
          return 1 * reverse
        }
      })
      return [
        {
          id: null,
          title: {
            ja: '未設定',
            en: '未設定'
          }
        },
        ...p
      ]
    },
    ...mapGetters([
      'OPTIONS',
      'LOADING',
      'works',
      'talent'
    ])
  }
}



// WEBPACK FOOTER //
// ./src/mixins/form/index.js